import React from "react";
import { Button, Container, ThemeProvider, createTheme } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import { useNavigate } from "react-router-dom";
import BannerImg from "../../images/banner-img.png";
import "./BannerTemplate.scss";

const theme = createTheme({
    breakpoints: {
        values: {
            xs: 0,
            sm: 576,
            md: 768,
            lg: 992,
            xl: 1620,
        },
    },
});

const BannerTemplate: React.FC = () => {
    const navigate = useNavigate();

    const handleGetStartedClick = () => {
        const target = document.getElementById("target-getstarted");
        if (target) {
            window.scrollTo({
                top: target.offsetTop,
                behavior: "smooth",
            });
        }
    };

    return (
        <section className="banner-section">
            <div className="banner-overlap">
                <ThemeProvider theme={theme}>
                    <Container maxWidth="xl">
                        <Grid
                            container
                            alignItems={{ lg: "flex-end", md: "flex-start" }}
                            flexDirection={{ md: "row", xs: "column" }}
                        >
                            {/* Left Side: Content */}
                            <Grid lg={6} md={6} sx={{ order: { md: 1, xs: 2 }, mt: { md: 0, xs: 6 } }}>
                                <div className="banner-content">
                                    <h1>CMS Interoperability: APIs for Data Exchange</h1>
                                    <p>
                                        Driving interoperability and patient access to health information by liberating
                                        patient data using CMS authority.
                                    </p>

                                    <div className="banner-btns">
                                        <Button
                                            className="btn btn-pink"
                                            variant="contained"
                                            onClick={handleGetStartedClick}
                                        >
                                            Get Started — It's Free
                                        </Button>

                                        <Button
                                            className="btn btn-blue"
                                            variant="contained"
                                            onClick={() => navigate("/api-documentation")}
                                        >
                                            API Documentation
                                        </Button>
                                    </div>
                                </div>
                            </Grid>

                            {/* Right Side: Image */}
                            <Grid lg={6} md={6} sx={{ order: { md: 2, xs: 1 } }}>
                                <div className="banner-image">
                                    <img src={BannerImg} alt="Banner" />
                                </div>
                            </Grid>
                        </Grid>
                    </Container>
                </ThemeProvider>
            </div>
        </section>
    );
};

export default BannerTemplate;
